<template>
	<div class="container remove-padding-margin">
		<div class="d-flex justify-content-center align-items-center vh-100" id="loadingPaged">
		<span
				class="spinner-border f-c-blue"
				role="status"
				aria-hidden="true"></span>
		</div>

		<div class="fixed-top bg-white">
			<div class="nav-center pageDefault">
				<div class="row justify-content-center align-items-center set-row">
					<div class="col-md-1 col-sm-1 col-1 remove-padding" @click="back" >
						<img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg" v-if="isLogin">
					</div>
					<div class="col-md-11 col-sm-11 col-11 text-center remove-padding">
						<div class="remove-margin">Subscribe Pesan Smartlink</div>
					</div>
				</div>
			</div>
		</div>
		<main class="add-padding-default">
			<div class="flex-100">
				<div class="flex-1 mar-top-60">
					<div class="font-16 line-height-25 letter-space-002 color-0000 mar-top-16 mar-bottom-20 ">
						<p>
							Dengan subscribe, maka anda menerima pesan update terkini yang dibroadcast oleh smartlink via whatsapp ke nomor {{telp}}
						</p>

						<div style="color:green" v-if="subscribe">
							status : Aktif (Subscribed)
						</div>
						<div style="color:red" v-else>
							status : Tidak Aktif (Not Subscribed)
						</div>

					</div>
					<div v-if="subscribe">
						<button type="button" class="btn btn-outline-danger btn-long mar-bot-12" id="btn2" @click="doSubscribe">Unsubscribe</button>
					</div>
					<div v-else>
						<button type="button" class="btn btn-outline-success btn-long mar-bot-12" id="btn22" @click="doSubscribe">Subscribe</button>
					</div>
				</div>
			</div>
		</main>



	</div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, required} from "vuelidate/lib/validators";

	export default {
		name: "SubscribeOwner",
		components: { ErrorMessage },
		data(){
			return{
				telp:this.$route.params.telp,
				subscribe:0,
				browser:navigator.userAgent,
				isLogin:0
			}
		},

		mounted(){
			 this.getSubscribeOwner()
			 this.isLogin = localStorage.getItem("token") !== null
		},
		methods: {
			copyToClipboard(id) {
				var copyText = document.getElementById(id);
				copyText.select();
				copyText.setSelectionRange(0, 99999)
				document.execCommand("copy");

				this.$toast.success("data tersailn")
			},

			back() {
				this.$router.push('/detailakunowner')
			},

			doSubscribe(){
				this.changeSubscribeOwner();
			},

			async getSubscribeOwner() {
				$('#loadingPaged').addClass('overlayLoading');
				// $('#loadingPaged').show();
				try {
					const dataSubscribe = new FormData
					dataSubscribe.append('telp', this.telp)

					const res = await this.$axios.post(this.$baseurl + '/masterData/subscribe/status?telp='+this.telp,dataSubscribe);
					if(res.data.status===true){
						$('#loadingPaged').removeClass('overlayLoading');
						this.subscribe=res.data.data.subscribe
					}else{
						$('#loadingPaged').removeClass('overlayLoading');
						// $('#loadingPaged').hide();
					}
				} catch (e) {
					this.$catch_error_response(e)
					$('#loadingPaged').removeClass('overlayLoading');
				}
			},
			async changeSubscribeOwner() {
				$('#loadingPaged').addClass('overlayLoading');
				// $('#loadingPaged').show();
				try {
					const dataSubscribe = new FormData
					dataSubscribe.append('telp', this.telp)

					const res = await this.$axios.post(this.$baseurl + '/masterData/subscribe/change?telp='+this.telp,dataSubscribe);
					if(res.data.status===true){
						$('#loadingPaged').removeClass('overlayLoading');
						this.$router.go()
					}else{
						$('#loadingPaged').removeClass('overlayLoading');
						// $('#loadingPaged').hide();
					}
				} catch (e) {
					this.$catch_error_response(e)
					$('#loadingPaged').removeClass('overlayLoading');
				}
			},


		}
	}
</script>

<style scoped>
	#loadingPaged.overlayLoading{
		visibility: visible;
		display: flex !important;

	}
	#loadingPaged{
		visibility: hidden;
		display: none !important;
	}

</style>